import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { PhoneNumbersComponent } from './phone-numbers.component';
import { PurchasedPhoneNumbersComponent } from './purchased-phone-numbers/purchased-phone-numbers.component';

@NgModule({
  declarations: [PhoneNumbersComponent, PurchasedPhoneNumbersComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [PhoneNumbersComponent, PurchasedPhoneNumbersComponent],
  entryComponents: [PhoneNumbersComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class PhoneNumbersModule { }
